import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog } from '../../../../types'
import { CmsConverterService, defaultFSCatalog } from '../../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class OpenPanelMainContentLeftRowConverter extends CmsConverterService<OpenPanelMainContentLeftRowData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      itemsLeft: formData.st_items_left ?? defaultFSCatalog,
      itemsRight: formData.st_items_right ?? defaultFSCatalog,
    }
  }
}

export const OPEN_PANEL_MAIN_CONTENT_LEFT_ROW_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, OpenPanelMainContentLeftRowData>>('OpenPanelMainContentLeftRowConverter')

export interface OpenPanelMainContentLeftRowData extends ConvertedComponentData {
  itemsLeft: FsCatalog;
  itemsRight: FsCatalog;
}
